import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  isDeletePaymentConfirmationOpenSelector,
  setDeletePaymentConfirmationOpenState,
  setPaymentMethod,
} from '../../../state';
import { ModalHeader } from '../../../../CommonComponents/OPL/Modal/ModalHeader';
import { ModalCloseButton } from '../../../../CommonComponents/OPL/Modal/ModalCloseButton';
import { ModalBody } from '../../../../CommonComponents/OPL/Modal/ModalBody';
import { Alert } from '../../../../CommonComponents/OPL/Alert/Alert';
import { Box } from '../../../../CommonComponents/OPL/Box/Box';
import { ModalFooter } from '../../../../CommonComponents/OPL/Modal/ModalFooter';
import { Button } from '../../../../CommonComponents/OPL/Button/Button';
import { Modal } from '../../../../CommonComponents/OPL/Modal/Modal';
import { useDeletePaymentMutation } from '../../../api/useDeletePaymentMutation';
import { routeParamsSelector } from '../../../../CommonComponents/Router/Selector';
import { PaymentMethod } from '../../../types';

export const DeletePaymentConfirmation: React.FC = () => {
  const isAlertOpen = useSelector(isDeletePaymentConfirmationOpenSelector);

  const { clientId } = useSelector(routeParamsSelector);

  const dispatch = useDispatch();

  const { mutateAsync: deletePayment, isLoading, error } = useDeletePaymentMutation();

  const onRequestClose = useCallback(() => {
    dispatch(setDeletePaymentConfirmationOpenState(false));
  }, [dispatch]);

  const deletePaymentCallback = useCallback(async () => {
    try {
      await deletePayment(clientId);

      onRequestClose();

      dispatch(setPaymentMethod(PaymentMethod.Disabled));
    } catch {
      // Ignore
    }
  }, [clientId, deletePayment, dispatch, onRequestClose]);

  if (!isAlertOpen) {
    return null;
  }

  return (
    <Modal
      isOpen
      onRequestClose={onRequestClose}
      size="medium"
      shouldCloseOnOverlayClick={false}
      shouldCloseOnEsc={false}
    >
      <ModalHeader variant="warning">Warning</ModalHeader>
      <ModalCloseButton onClick={onRequestClose} />

      <ModalBody>
        {error && <Alert message={error.message} variant="error" mb="16" />}

        <Box>Are you sure you want to remove your payment information?</Box>
      </ModalBody>

      <ModalFooter>
        <Button onClick={onRequestClose} variant="subtleInactive" mr="12">
          Cancel
        </Button>

        <Button variant="error" onClick={deletePaymentCallback} isLoading={isLoading}>
          Remove
        </Button>
      </ModalFooter>
    </Modal>
  );
};
